export const OpportunityModel = () => {
  const create = (obj) => {
    if (obj?.loan_details?.amount_requested)
      obj.loan_details.amount_requested = parseFloat(
        obj.loan_details.amount_requested
      );
    if (isValidAmount(obj.loan_details.amount_requested)) {
      return obj;
    }
    const e = new Error();
    e.data = "Please enter a valid number for Requested Amount";
    throw e;
  };

  const isValidAmount = (amount) => {
    return !isNaN(+amount);
  };

  return Object.freeze({
    create,
  });
};
